import * as React from "react";
const SVGComponent = (props) => {
    const specificPath = window.location.pathname === "/home";

    return (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x="2.5"
      y="2.5"
      width="6.25"
      height="8.75"
      rx="1.5"
      stroke={specificPath ? "#ffffff" : "#667085"}
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect
      x="2.5"
      y="13.75"
      width="6.25"
      height="3.75"
      rx="1.5"
      stroke={specificPath ? "#ffffff" : "#667085"}
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect
      x="11.25"
      y="2.5"
      width="6.25"
      height="3.75"
      rx="1.5"
      stroke={specificPath ? "#ffffff" : "#667085"}
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect
      x="11.25"
      y="8.75"
      width="6.25"
      height="8.75"
      rx="1.5"
      stroke={specificPath ? "#ffffff" : "#667085"}
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
    )
};
export default SVGComponent;
